/* eslint-disable @typescript-eslint/naming-convention */

import { Alchemy } from 'alchemy-sdk'

export const getTransaction = async (transactionHash: string) => {
    const alchemyInstance = new Alchemy({ apiKey: process.env.ALCHEMY_API_KEY })
    try {
        const response = await alchemyInstance.core.getTransaction(transactionHash)
        const receipts = await alchemyInstance.core.getTransactionReceipts({
            blockHash: response?.blockHash ? response.blockHash : '',
        })
        return {
            success: true,
            data: receipts,
        }
    } catch (error) {
        return {
            success: false,
            error: error as unknown as string,
        }
    }
}
